export const FORWARDER_REPORT_TPL_PATH: string = 'assets/docs/forwarder-report.xlsx';
export const TRN_TEMPLATE_TPL_PATH: string = 'assets/docs/trn-template.xlsx';
export const TTN_TEMPLATE_TPL_PATH: string = 'assets/docs/ttn-template.xlsx';
